import { render } from "./DeleteConfirmationModal.vue?vue&type=template&id=31ec6e81&scoped=true"
import script from "./DeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationModal.vue?vue&type=script&lang=js"

import "./DeleteConfirmationModal.vue?vue&type=style&index=0&id=31ec6e81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ec6e81"]])

export default __exports__